import { TagsOutlined } from '@ant-design/icons';
import { Empty, Segmented } from 'antd';
import React, { useEffect, useState } from 'react';
import { BiSolidPackage } from 'react-icons/bi';
import Attributes from './tabs/attributes';
import CategoryProducts from './tabs/products';

const MarketplaceCategoryDetails = ({ category }) => {
  const [detailsTab, setDetailsTab] = useState('mp-category-attributes');

  useEffect(() => {
    if (category) {
      setDetailsTab('mp-category-attributes');
    }
  }, [category?.id, category?.name]);

  const onDetailsTabChange = (value) => {
    setDetailsTab(value);
  };

  const segmentedOptions = [
    {
      label: 'Attributs',
      value: 'mp-category-attributes',
      icon: <TagsOutlined />,
    },
    {
      label: 'Produits',
      value: 'mp-category-products',
      icon: <BiSolidPackage />,
    },
  ];

  if (!category) {
    return (
      <div
        style={{
          height: '100%',
          minHeight: '500px',
          margin: '16px 0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Empty description="Sélectionnez une catégorie pour voir les détails" />
      </div>
    );
  }

  return (
    <div>
      <div>
        <h3 style={{ margin: 0 }}>Catégorie : {category?.label}</h3>
        <span>
          <b>Code :</b> {category?.name || 'N/A'}
        </span>
      </div>
      <Segmented
        value={detailsTab}
        options={segmentedOptions}
        onChange={onDetailsTabChange}
        block
      />
      <div
        style={{
          maxHeight: 'calc(100vh - 200px)',
          overflowY: 'auto',
          padding: '16px 0',
          scrollBehavior: 'smooth',
        }}
      >
        {detailsTab === 'mp-category-attributes' && (
          <Attributes category={category} />
        )}
        {detailsTab === 'mp-category-products' && (
          <CategoryProducts category={category} />
        )}
      </div>
    </div>
  );
};

export default MarketplaceCategoryDetails;
